import $ from 'jquery'
import modelTemplate from 'templates/sketchfab-model.pug'

import BaseComponent from 'scripts/components/base-component'
import getBreakpoint from 'scripts/utils/get-breakpoint'

class SketchfabModel extends BaseComponent {
  static componentName = 'sketchfab-model'

  static DOMEvents = {
    click: 'onElementClick',
    slideStop: 'onSlideStop'
  }

  init () {
    if (this.shouldDisplayPlaceholder()) {
      return
    }

    this.renderModel()
  }

  shouldDisplayPlaceholder () {
    return getBreakpoint() !== 'desktop'
  }

  onElementClick () {
    if (this.$model) {
      return this.displayModel(true)
    }

    this.renderModel()
  }

  onSlideStop () {
    if (this.$model && this.shouldDisplayPlaceholder()) {
      this.displayModel(false)
    }
  }

  renderModel () {
    const modelID = this.$element.data('sketchfab-id')

    this.$model = $(modelTemplate({ modelID }))
    this.$element.append(this.$model)
  }

  displayModel (value) {
    this.$model.toggleClass('hidden', !value)
  }
}

export default ($el) => new SketchfabModel($el).init()

export { SketchfabModel as Component }
